import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingButton } from '../../../../components/LoadingButton';
import * as routing from '../../../../constants/Routing';
import { useSessionLogout } from '../../../../hooks/session/useSessionLogout';
import { AccountDeletionSlide } from './AccountDeletionSlide';
import { useDeleteAccount } from './useDeleteAccount';

interface AccountDeletionDialogProps {
  onClose: () => void;
}

export const AccountDeletionDialog = ({ onClose }: AccountDeletionDialogProps) => {
  const navigate = useNavigate();
  const { run: deleteAccount, isLoading: isDeletingAccount, success: deleteAccountSuccess } = useDeleteAccount();
  const { run: logout, success: logoutSuccess, isLoading: logoutLoading } = useSessionLogout();

  useEffect(() => {
    if (deleteAccountSuccess) {
      logout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteAccountSuccess]);

  useEffect(() => {
    if (logoutSuccess) {
      navigate(routing.AUTH);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logoutSuccess]);

  const onDeleteAccount = async () => {
    console.info(`onDeleteAccount`);
    deleteAccount();
  };

  return (
    <AccountDeletionSlide
      children={
        <Grid
          style={{
            padding: `0 20px`,
            display: `flex`,
            justifyContent: `center`,
            alignItems: `center`,
            flexDirection: `column`,
          }}
        >
          <LoadingButton
            style={{
              width: `100%`,
              backgroundColor: RoutalPalette.error.medium,
              borderColor: RoutalPalette.error.medium,
              color: RoutalPalette.white,
            }}
            isLoading={isDeletingAccount || logoutLoading || deleteAccountSuccess} // There is a small flicker between deleting the account and the logout.
            intlId="drivers.account_deletion_dialog.confirm"
            onClick={() => {
              if (!isDeletingAccount && !logoutLoading && !deleteAccountSuccess) {
                onDeleteAccount();
              }
            }}
          />
        </Grid>
      }
      onClose={() => {
        !isDeletingAccount && !logoutLoading && !deleteAccountSuccess && onClose();
      }}
      openSlide={true}
      titleId="drivers.account_deletion_dialog.title"
      subtitleId="drivers.account_deletion_dialog.subtitle"
    />
  );
};
